module.exports = __webpack_public_path__ + "img/icon_menu_twitter_darkgrey.aa2d3c44.svg";